import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";

import Home from "@/pages/Home";
import DevicesPage from "@/pages/DevicesPage";
import DeviceDetail from "@/pages/DeviceDetail";
import AppsPage from "@/pages/AppsPage";
import VideosPage from "@/pages/VideosPage";
import FAQPage from "@/pages/FAQPage";
import StatusPage from "@/pages/StatusPage";
import SupportPage from "@/pages/SupportPage";
import TutorialDetail from "@/pages/TutorialDetail";
import FavoritesPage from "@/pages/FavoritesPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
      <SettingsProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster position="top-center" theme="dark" richColors />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/dispositivos" element={<DevicesPage />} />
              <Route path="/dispositivos/:slug" element={<DeviceDetail />} />
              <Route path="/aplicativos" element={<AppsPage />} />
              <Route path="/videos" element={<VideosPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/status" element={<StatusPage />} />
              <Route path="/suporte" element={<SupportPage />} />
              <Route path="/favoritos" element={<FavoritesPage />} />
              <Route path="/tutorial/:slug" element={<TutorialDetail />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/painel" element={<AdminDashboard />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </SettingsProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
